module.exports = __webpack_public_path__ + "media/images/logo-12f51b32.svg";